<app-painel-comissoes [tituloPainel]="config.titulo" [descricaoPainel]="config.subtitulo" [iconePainel]="config.icone" [filtrosTemplate]="filtros" [conteudoTemplate]="conteudo" [ocultarFiltros]="modoAnalitico">
    <ng-template #filtros>
        <label class="mapa-filtro" for="producao-data-inicio">
            <span class="mapa-filtro-label">Período Inicial</span>
            <p-datepicker id="producao-data-inicio" [(ngModel)]="dataInicioDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
        </label>
        <label class="mapa-filtro" for="producao-data-fim">
            <span class="mapa-filtro-label">Período Final</span>
            <p-datepicker id="producao-data-fim" [(ngModel)]="dataFimDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
        </label>
        <div class="filtros-acoes">
            <p-button icon="pi pi-refresh" label="Atualizar" type="button" [loading]="carregando" (onClick)="carregar()"></p-button>
            <p-button icon="pi pi-filter-slash" label="Restaurar padrão" type="button" severity="secondary" [outlined]="true" title="Volta o período para o ano corrente" (onClick)="limpar()"></p-button>
        </div>
    </ng-template>

    <ng-template #conteudo>
        @if (!modoAnalitico) {
            <section class="resumo-cards" aria-label="Resumo da producao">
                <article class="resumo-card">
                    <span class="resumo-icone"><i class="pi pi-users"></i></span>
                    <div class="resumo-info">
                        <span class="resumo-label">Total de reuniões</span>
                        <strong class="resumo-valor">{{ totalReunioes | number }}</strong>
                    </div>
                </article>
                <article class="resumo-card">
                    <span class="resumo-icone"><i class="pi pi-user"></i></span>
                    <div class="resumo-info">
                        <span class="resumo-label">{{ rotuloPessoas }} no ranking</span>
                        <strong class="resumo-valor">{{ totalPessoasRanking | number }}</strong>
                    </div>
                </article>
                <article class="resumo-card">
                    <span class="resumo-icone"><i class="pi pi-trophy"></i></span>
                    <div class="resumo-info">
                        <span class="resumo-label">Maior produção</span>
                        <strong class="resumo-valor resumo-valor-inline"
                            >{{ maiorProducao | number }} <span>{{ rotuloReuniao(maiorProducao) }}</span></strong
                        >
                    </div>
                </article>
                <article class="resumo-card">
                    <span class="resumo-icone"><i class="pi pi-calendar"></i></span>
                    <div class="resumo-info">
                        <span class="resumo-label">Período analisado</span>
                        <strong class="resumo-valor resumo-periodo">{{ periodoAnalisado }}</strong>
                    </div>
                </article>
            </section>

            @if (carregando) {
                <div class="producao-skeleton">
                    <p-skeleton width="100%" height="260px"></p-skeleton>
                    <p-skeleton width="100%" height="320px"></p-skeleton>
                </div>
            } @else if (ranking.length) {
                <section class="podio" aria-label="Pódio dos três primeiros">
                    @for (item of podio; track item.posicao) {
                        <div
                            class="podio-card"
                            [class.podio-1]="item.posicao === 1"
                            [class.podio-2]="item.posicao === 2"
                            [class.podio-3]="item.posicao === 3"
                            role="button"
                            tabindex="0"
                            [attr.aria-label]="'Ver reuniões de ' + item.nome"
                            (click)="abrirAnalitico(item)"
                            (keydown.enter)="abrirAnalitico(item)"
                            (keydown.space)="$event.preventDefault(); abrirAnalitico(item)"
                        >
                            <div class="podio-rank">
                                <i class="pi pi-crown podio-coroa" aria-hidden="true"></i>
                                <span>{{ item.posicao }}º</span>
                            </div>
                            @if (item.posicao === 1) {
                                <span class="podio-laurel podio-laurel-esquerda" aria-hidden="true"></span>
                                <span class="podio-laurel podio-laurel-direita" aria-hidden="true"></span>
                            }
                            <div class="podio-foto">
                                @if (item.avatar) {
                                    <img [src]="item.avatar" [alt]="'Foto de ' + item.nome" />
                                } @else {
                                    <p-avatar [label]="item.iniciais" shape="circle" size="xlarge"></p-avatar>
                                }
                            </div>
                            <span class="podio-nome" [title]="item.nome">{{ item.nome }}</span>
                            <span class="podio-total">{{ item.total | number }}</span>
                            <span class="podio-legenda">{{ rotuloReuniao(item.total) }}</span>
                        </div>
                    }
                </section>

                @if (demais.length) {
                    <section class="ranking-lista" aria-label="Demais posições do ranking">
                        @for (item of demais; track item.posicao) {
                            <div
                                class="ranking-linha"
                                role="button"
                                tabindex="0"
                                [attr.aria-label]="'Ver reuniões de ' + item.nome"
                                (click)="abrirAnalitico(item)"
                                (keydown.enter)="abrirAnalitico(item)"
                                (keydown.space)="$event.preventDefault(); abrirAnalitico(item)"
                            >
                                <span class="ranking-posicao">{{ item.posicao }}º</span>
                                <div class="ranking-foto">
                                    @if (item.avatar) {
                                        <img [src]="item.avatar" [alt]="'Foto de ' + item.nome" />
                                    } @else {
                                        <p-avatar [label]="item.iniciais" shape="circle"></p-avatar>
                                    }
                                </div>
                                <div class="ranking-info">
                                    <span class="ranking-nome" [title]="item.nome">{{ item.nome }}</span>
                                    <span class="ranking-barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="item.percentual" [attr.aria-label]="item.percentual + '% do líder'"
                                        ><span [style.width.%]="item.percentual"></span
                                    ></span>
                                </div>
                                <span class="ranking-total-bloco">
                                    <strong class="ranking-total">{{ item.total | number }}</strong>
                                    <span class="ranking-total-label">{{ rotuloReuniao(item.total) }}</span>
                                </span>
                            </div>
                        }
                    </section>
                }
            } @else {
                <div class="producao-vazio">
                    <i class="pi pi-users"></i>
                    <span>{{ config.legendaVazio }}</span>
                </div>
            }
        } @else {
            <app-detalhamento-pendencias
                [indicador]="obterIndicadorAnalitico()"
                [linhas]="linhasAnalitico"
                [first]="firstAnalitico"
                [rows]="rowsAnalitico"
                [totalRecords]="totalRegistrosAnalitico"
                [carregando]="carregandoAnalitico"
                [rotuloVoltar]="'Voltar'"
                [voltarNoCard]="true"
                [permitirVisualizacaoCard]="true"
                [colunaUf]="config.colunaUf"
                [colunaIdentificador]="'REUNIÃO'"
                [colunaNome]="'COMISSÃO'"
                [colunaSituacao]="'STATUS'"
                [colunaDetalhe]="'DATA'"
                (voltar)="voltarRanking()"
                (paginaAlterada)="onPageChangeAnalitico($event)"
            ></app-detalhamento-pendencias>
        }
    </ng-template>
</app-painel-comissoes>
